import { CryptoRewardsCryptoWalletResponseItem } from 'components/features/rewards/rewardsPane/types/apiResponses'
import { CryptoWalletCurrency } from 'components/features/rewards/rewardsPane/types/cryptoWallet'


export const normalizeWalletItem = (cryptoWalletItem: CryptoRewardsCryptoWalletResponseItem): CryptoWalletCurrency => ({
  id: cryptoWalletItem.ticker,
  performanceAllTimeChangeUSD: parseFloat(cryptoWalletItem.performance?.all_time?.absolute ?? '') || null,
  performanceAllTimePercent: parseFloat(cryptoWalletItem.performance?.all_time?.percentage ?? '') || null,
  performanceLas24HoursChangeUSD: parseFloat(cryptoWalletItem.performance?.['24_hours']?.absolute ?? '') || null,
  performanceLas24HoursChangePercent: parseFloat(cryptoWalletItem.performance?.['24_hours']?.percentage ?? '') || null,
  amountInvested: parseFloat(cryptoWalletItem.amount_invested_usd),
  isEmpty: !!cryptoWalletItem.is_empty,
  balance_crypto: cryptoWalletItem.balance_crypto,
  price: cryptoWalletItem.price,
})

